/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import { parseISO, subMonths } from 'date-fns';
import uniq from 'lodash/uniq';
import { formatDate, usdFormatter } from '../../../../lib/helpers';
import { useStoragePaymentHistory, useStorageAccountInfo } from '../queries';

function StorageViewHistory() {
  const { data: paymentsData, isFetching: isFetchingPaymentsData } =
    useStoragePaymentHistory();
  const { data: accountInfoData } = useStorageAccountInfo();
  const [selectedDateFilter, setSelectedDateFilter] = useState('');
  const [filteredPayments, setFilteredPayments] = useState(null);

  const dateFilterOptions = useMemo(() => {
    if (!paymentsData) {
      return [];
    }
    return uniq(
      paymentsData.map(({ date }) => parseISO(date).getFullYear().toString())
    );
  }, [paymentsData]);

  useEffect(() => {
    if (paymentsData) {
      if (!selectedDateFilter) {
        const twelveMonthsAgo = subMonths(new Date(), 12);

        setFilteredPayments(
          paymentsData.filter(
            (payment) => parseISO(payment.date) >= twelveMonthsAgo
          )
        );
      } else {
        setFilteredPayments(
          paymentsData.filter(
            (payment) =>
              parseISO(payment.date).getFullYear().toString() ===
              selectedDateFilter
          )
        );
      }
    }
  }, [paymentsData, selectedDateFilter]);

  return (
    <div className="portal-inner has-tabs">
      <Link to="/portal/storage/payments" className="back-link">
        <FontAwesomeIcon icon={faChevronLeft} />
        Return to Payments
      </Link>
      <Row>
        <Col>
          <div className="info-box">
            <div className="info-header">
              <h3>Monthly Payment</h3>
            </div>
            <div className="info-content">
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <label>Plan</label>
                    <div>
                      <strong>
                        {accountInfoData &&
                          usdFormatter.format(accountInfoData.monthlyCharge)}
                      </strong>
                      /month
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <label>Next Billing Date</label>
                    <div>
                      {accountInfoData &&
                        formatDate(accountInfoData.nextBillingDate)}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <div className="info-box">
            <div className="info-header">
              <h3>Billing History</h3>

              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <Form.Group as={Row} className="align-items-center">
                  <Col sm={4}>
                    <Form.Label className="text-white">Date Range</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      disabled={isFetchingPaymentsData}
                      value={selectedDateFilter}
                      onChange={(e) => {
                        setSelectedDateFilter(e.target.value);
                        e.preventDefault();
                      }}
                    >
                      <option value="">Previous 12 months</option>
                      {dateFilterOptions.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Form>
            </div>
            <div className="info-content">
              {!isFetchingPaymentsData && (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Invoice Number</th>
                      {/* <th>Service Period</th> */}
                      <th>Payment Method</th>
                      <th className="text-end">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPayments &&
                      filteredPayments.map((payment) => (
                        <tr key={payment.recordNumber}>
                          <td>{formatDate(payment.date, 'M/d/yyyy')}</td>
                          <td>{payment.isInvoice && payment.recordNumber}</td>
                          {/* <td>
                            {payment.isInvoice &&
                              `One month of storage beginning on ${formatDate(
                                subDays(parseISO(payment.date), 30)
                              )}`}
                          </td> */}
                          <td>
                            {payment.paymentMethodLastFour
                              ? payment.paymentMethodLastFour
                              : ''}
                          </td>
                          <td className="text-end">
                            {usdFormatter.format(parseFloat(payment.amount))}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}

              {isFetchingPaymentsData && (
                <div className="text-center py-5">
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    spin
                    size="3x"
                    style={{ color: '#953263' }}
                  />
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StorageViewHistory;
